@use '@design/design-tokens/typography/typography' as *;
@use '../table-primitives' as *;

@layer design-system {
  .tableHeader {
    background-color: var(--background-default);
    border-bottom: 1px solid var(--border-soft);
    padding: 12px;
    white-space: nowrap;
    color: var(--text-soft);
    @include typography-v2-body-xs;
    vertical-align: middle;

    &.isSortable {
      &:hover {
        cursor: pointer;
      }
    }

    &.isLeftOver {
      border-left: 2px solid var(--primary-color);
    }

    &.isRightOver {
      border-right: 2px solid var(--primary-color);
    }

    &.fixed {
      @include fixed-table-cell;
    }

    &.isHoverEnabled {
      &:hover {
        background-color: var(--surface-hover);
      }
    }
  }

  .filterIcon {
    fill: var(--text-soft);

    &.isSorted {
      fill: var(--text-primary);
    }
  }

  .label {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
